import { render } from "./Newsssunway.vue?vue&type=template&id=85965f32&scoped=true"
import script from "./Newsssunway.vue?vue&type=script&lang=js"
export * from "./Newsssunway.vue?vue&type=script&lang=js"

import "./Newsssunway.vue?vue&type=style&index=0&id=85965f32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85965f32"]])

export default __exports__